export default "__VITE_ASSET__Ccqezx_P__ 640w, __VITE_ASSET__B3TyNals__ 1024w, __VITE_ASSET__BdkeXiqM__ 1920w";